export class ImageResponse { 
    dbPath: string;
    dbPath1: string;
    dbPath2: string;
    dbPath3: string;
    dbPath4: string;
    dbPath5: string;
}
